import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useShoppingCartQuery } from '@dtx-company/inter-app/src/redux/slices/flowcodeApiSlice/printStoreQueries'

export function useCartItemsCount(): {
  itemsCount: number
  isLoading: boolean
} {
  const { isAuthenticated } = useAuthState()
  const { data, isLoading } = useShoppingCartQuery({}, { skip: !isAuthenticated })
  return {
    itemsCount: data?.shoppingCart?.items?.length ?? 0,
    isLoading: isLoading
  }
}
